// add to cart button price code
function updateCartButtonPrice() {
    const salePrice = document.querySelector('sale-price');
    const btn = document.querySelector('buy-buttons button[type="submit"]');

    if (!salePrice || !btn) return;

    if (!btn.dataset.originalText) {
        btn.dataset.originalText = btn.textContent.trim();
    }

    const originalText = btn.dataset.originalText;
    const price = salePrice.textContent.trim().replace('Angebot', '').trim();

    const newText = `${originalText} - ${price}`;

    if (btn.textContent.trim() !== newText) {
        btn.textContent = newText;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(updateCartButtonPrice, 800);

    const priceObserver = new MutationObserver(() => {
        updateCartButtonPrice();
    });

    const priceContainer = document.querySelector('sale-price');
    if (priceContainer) {
        priceObserver.observe(priceContainer, {
            childList: true,
            characterData: true,
            subtree: true
        });
    }

    const buyButtonsWrapper = document.querySelector('buy-buttons')?.closest('[id]') || document.body;
    const buttonObserver = new MutationObserver(() => {
        setTimeout(updateCartButtonPrice, 100);
    });

    buttonObserver.observe(buyButtonsWrapper, {
        childList: true,
        subtree: true
    });
});
// add to cart button price code

// custom size guide popup code

document.addEventListener('click', function(e){
    const trigger = e.target.closest('.variant-option-link');
    if(trigger){
        const popupId = trigger.dataset.popup;
        document
            .querySelector('.custom-popup[data-popup="'+ popupId +'"]')
            ?.classList.add('active');
    }
    if(e.target.classList.contains('popup-close')){
        e.target.closest('.custom-popup').classList.remove('active');
    }
});
// custom size guide popup code

// custom product option 

function validateHeight() {
    const input = document.querySelector('.blog-height-box input');
    const hiddenInput = document.querySelector('.hidden-height-input');
    const error = document.querySelector('.height-error');
    if (!input || !hiddenInput) return true;

    const value = parseInt(input.value, 10);
    const isInvalid = input.value !== '' && (value < 35 || value > 50);

    if (error) error.style.display = isInvalid ? 'block' : 'none';

    if (!input.value || isInvalid) {
        hiddenInput.disabled = true;
        hiddenInput.value = '';
    } else {
        hiddenInput.disabled = false;
        hiddenInput.value = input.value;
    }

    return !isInvalid;
}

document.addEventListener('input', function (e) {
    if (e.target.closest('.blog-height-box input')) validateHeight();
});

document.addEventListener('click', function (e) {
    const btn = e.target.closest('button[type="submit"]');
    if (!btn) return;

    if (!validateHeight()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}, true);

document.addEventListener('DOMContentLoaded', validateHeight);

// custom product option code and

// review section to review widgets scroll code
document.querySelectorAll('.holz-gallery-intro__url').forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();

    document.querySelector('#judgeme_product_reviews')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
});
// review section to review widgets scroll code